import { render } from "./PaymentsModal.vue?vue&type=template&id=30891f8f&scoped=true"
import script from "./PaymentsModal.vue?vue&type=script&lang=js"
export * from "./PaymentsModal.vue?vue&type=script&lang=js"

import "./PaymentsModal.vue?vue&type=style&index=0&id=30891f8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30891f8f"]])

export default __exports__